import { Datepicker, type DatepickerProps } from '../Datepicker/Datepicker';

// MondayPicker always supplies its own Monday-only filterDate, so callers
// can't override it -- omit it from the public props to avoid implying they can.
export type MondayPickerProps = Omit<DatepickerProps, 'filterDate'>;

const isMonday = (date: Date) => date.getDay() === 1;

function MondayPicker(props: MondayPickerProps) {
  return <Datepicker {...props} filterDate={isMonday} />;
}

export { MondayPicker };
